import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import SearchableAsyncSelect, { type SearchableAsyncSelectProps } from '../SearchableAsyncSelect';
import './ControlledSearchableAsyncSelect.css';

export interface ControlledSearchableAsyncSelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TMeta = unknown,
> extends Omit<SearchableAsyncSelectProps<TMeta>, 'error' | 'value' | 'onChange'> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  error?: FieldError;
}

export default function ControlledSearchableAsyncSelect<
  TFieldValues extends FieldValues = FieldValues,
  TMeta = unknown,
>({
  name,
  control,
  error: errorProp,
  className = '',
  disabled,
  ...props
}: ControlledSearchableAsyncSelectProps<TFieldValues, TMeta>) {
  const { field, fieldState } = useController({
    control,
    name,
    disabled,
  });

  const error = fieldState.error || errorProp;

  return (
    <div className={`controlled-searchable-async-select-wrapper ${className}`.trim()}>
      <SearchableAsyncSelect<TMeta>
        {...props}
        value={field.value ?? null}
        onChange={(v) => field.onChange(v)}
        onBlur={field.onBlur}
        disabled={disabled}
        error={error ? error.message : undefined}
      />
    </div>
  );
}
